import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';

import IsEmpty from '../lib/IsEmpty';

// propName is the prop whose validity will render the component. i.e. 'isLoading'
// 'message' is the message that the spinner will display while the content is loading. i.e 'loading templates'

const LoaderHOC = (propName, message, mode) => (WrappedComponent) => {
  return class LoaderHOC extends Component {
    render() {
      const content = mode === 'save' ? 'Saving ' : 'Loading ' + message;
      return this.props[propName] ? (
        <Loader indeterminate content={content} size="small" active />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };
};

LoaderHOC.propTypes = {
  templateEventData: PropTypes.object.isRequired,
};

export default LoaderHOC;



// WEBPACK FOOTER //
// ./src/common/HOC/LoaderHOC.js